module.exports = __webpack_public_path__ + "static/media/car2.dc8bbc8f.webp";